/**
 * The device's local day (part 19b log, table D6), apart from the goals' tally so a worker that only needs the day (the
 * backup lock's put-off, part 41b) never loads the settings and the editor they name.
 */

/** D6: the device's local day at `now` (milliseconds), `zone` minutes ahead of UTC, as `YYYY-MM-DD`. */
export function localDay(now: number, zone: number): string {
  return new Date(now + zone * 60_000).toISOString().slice(0, 10);
}
